import type React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AppSidebar } from '@/components/app-sidebar';
import { PageTransition } from '@/components/page-transition';
import { SidebarInset, SidebarProvider, SidebarTrigger } from '@/components/ui/sidebar';
import { CompanyLogoProvider } from '@/contexts/company-logo-context';

export const AppLayout: React.FC = () => {
  const location = useLocation();
  return (
    <CompanyLogoProvider>
      <SidebarProvider
        style={
          {
            '--sidebar-width': 'calc(var(--spacing) * 60)',
          } as React.CSSProperties
        }
      >
        <AppSidebar variant="inset" />
        <SidebarInset className="border-t-0">
          <div className="flex flex-1 flex-col bg-muted/50">
            {/* Mobile-only control to open the navigation drawer; the sidebar is always visible on desktop. */}
            <SidebarTrigger className="m-2 md:hidden" />
            <div className="@container/main flex flex-1 flex-col gap-2">
              <PageTransition key={location.pathname}>
                <Outlet />
              </PageTransition>
            </div>
          </div>
        </SidebarInset>
      </SidebarProvider>
    </CompanyLogoProvider>
  );
};
